export enum EDependentsTypes {
  SINGLE = 'Single',
  SINGLE_WITH_DEPENDENTS = 'Single with Dependents',
  MARRIED = 'Married',
  MARRIED_WITH_DEPENDENTS = 'Married with Dependents',
  MIL_TO_MIL = 'Mil 2 Mil',
  MIL_TO_MIL_WITH_DEPENENTS = 'Mil 2 Mil with Dependents'
}
